<div
    class="agpr-briefingInsightUpsellCard"
    [class.expanded]="!collapsed"
    [ngClass]="{
        'agpr-briefingInsightUpsellCard--light': !isWhiteLabeledBrand,
        'agpr-briefingInsightUpsellCard--primary': isWhiteLabeledBrand
    }"
>
    <agpr-panel
        [collapsed]="true"
        (collapsedChange)="collapsed = $event;"
        [marginTop]="0"
        styleClass="agpr-briefingInsightUpsellCard-panel"
    >
        <ng-template #panelHeader>
            <div class="agpr-briefingInsightUpsellCard-heading">
                <span
                    class="agpr-briefingInsightUpsellCard-icon fa-kit-duotone fa-agpr-insights"
                    aria-hidden="true"
                ></span>
                <div>{{ 'Mention.insights.upsell.heading' | localize}}</div>
            </div>
        </ng-template>
        <div class="agpr-briefingInsightUpsellCard-content">
            <div class="agpr-briefingInsightUpsellCard-message">{{ 'Mention.insights.upsell.message' | localize}}</div>
            <ul class="agpr-briefingInsightUpsellCard-messageBullets">
                <li>{{ 'Mention.insights.upsell.message.bullet1' | localize}}</li>
                <li>{{ 'Mention.insights.upsell.message.bullet2' | localize}}</li>
                <li>{{ 'Mention.insights.upsell.message.bullet3' | localize}}</li>
            </ul>
            <div class="agpr-briefingInsightUpsellCard-message">{{ 'Mention.insights.upsell.message.callForAction' | localize}}</div>
            <agpr-button
                [id]="id + '_unlock'"
                class="agpr-briefingInsightUpsellCard-button"
                label="Mention.insights.upsell.unlock"
                [style]="buttonTypes.primary"
                (click)="unlock()"
                ariaLabel="Mention.insights.upsell.message.callForAction"
            ></agpr-button>
        </div>
    </agpr-panel>
</div>
